import {
  ComponentType,
  ImgHTMLAttributes,
  ReactNode,
  useEffect,
  useMemo,
  useState,
} from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import {} from "../../core/feature/store";
import { setToken } from "../../core/feature/token/tokenSlice";
import { setUser } from "../../core/feature/user/userSlice";
import { credentialCheck } from "../../core/service/api";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import { ChevronDown, ChevronLeft, TextAlignJustify, X } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard, Autoplay, Pagination, Navigation } from "swiper";
import {
  ClipboardIcon,
  ClipboardroundIcon,
  DesktopSavingIcon,
  ReversalIcon,
  SaldoIcon,
  SaldoroundIcon,
  SavingIcon,
  SwitchIcon,
  TotalIcon,
  TotalroundIcon,
  TransferIcon,
  TransferroundIcon,
} from "./icons";
import {
  getAccountSaving,
  getDataSaving,
  getDetailMutationSaving,
  getMutationSaving,
  getSummarySaving,
} from "../../core/service/api_saving";
import Company from "../../core/models/company";
import { useAppSelector } from "../../core/feature/hooks";
import Config from "../../config/Config";
import User from "../../core/models/user";
import { SavingType } from "./savingTypes";
import { BalanceCard } from "./components/balanceCard";
import { useTranslation } from "react-i18next";

const SavingWeb = (props: any) => {
  const dispatch = useDispatch();
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const env = Config.BaseUrlDev;
  const company: Company = useAppSelector((state) => state.company.company);
  const user: User = useAppSelector((state) => state.user.user);

  const [activeCallerId, setActiveCallerId] = useState<string | null>(null);
  const [callerIdentities, setCallerIdentities] = useState<any[]>([]);
  const [accounts, setAccounts] = useState<any[]>([]);
  const [activeUser, setActiveuser] = useState<any>(
    user.accounts[0].callerIdentities[0] || {},
  );

  const [page, setPage] = useState<number>(0);
  const [size, setSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [number, setNumber] = useState<number>(0);
  const [numberOfElements, setNumberOfElements] = useState<number>(0);

  const showingFrom = total === 0 ? 0 : number * size + 1;
  const showingTo = number * size + numberOfElements;
  const [activeSaving, setActiveSaving] = useState<{
    coaCode: string;
    configId: string;
  } | null>(null);
  const [summaryByCoa, setSummaryByCoa] = useState<any>(null);
  const [globalSummary, setGlobalSummary] = useState({
    totalBalance: 0,
    totalDepositAmount: 0,
    totalWithdrawalAmount: 0,
    totalTransaction: 0,
  });
  const [mutationSaving, setMutationSaving] = useState<Record<string, any[]>>(
    {},
  );
  const [dataMutations, setDataMutations] = useState<any>();
  const [detail, setDetail] = useState<any>(null);
  const activeAccount = accounts.find(
    (acc) => acc.configId === activeSaving?.configId,
  );
  const today = new Date();
  const startDate = new Date();
  startDate.setMonth(today.getMonth() - 1);
  const formatDate = (date: Date) => {
    const d = String(date.getDate()).padStart(2, "0");
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    return `${d}-${m}-${y}`;
  };
  const [dateSort, setDateSort] = useState<"dateTime,Desc" | "dateTime,Asc">(
    "dateTime,Desc",
  );

  const totalBalance = accounts.reduce(
    (sum, acc) => sum + Number(acc.balance || 0),
    0,
  );

  const mutationDateRange = `${formatDate(startDate)}/${formatDate(today)}`;
  const [pagination, setPagination] = useState({
    page: 0,
    pages: 0,
    size: 10,
  });

  const [isAccOpen, setIsAccOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openArrow, setOpenArrow] = useState<string[]>([]);
  const toggleArrow = (key: string) => {
    setOpenArrow((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  const changePage = (val: number) => {
    setPage(val);
  };
  const changeSize = (val: number) => {
    setSize(val);
  };

  const [buttonAcc, setButtonAcc] = useState<string | null>(null);
  const [totalTransaksi, setTotalTransaksi] = useState(0);

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  useEffect(() => {
    const storedToken = localStorage.getItem("token_redux");
    if (token) {
      localStorage.setItem("token_redux", token);
      dispatch(setToken(token));
    } else if (!storedToken) {
      navigate("/");
      return;
    }
    credentialCheck()
      .then((res) => {
        dispatch(setUser(res.data.user));
        const identities = res.data.user?.accounts?.[0]?.callerIdentities ?? [];
        if (!identities.length) {
          navigate("/");
          return;
        }
        setCallerIdentities(identities);
        setActiveCallerId(identities[0].callerId);
      })
      .catch(() => navigate("/"));
  }, [token]);

  useEffect(() => {
    console.log(activeCallerId);

    if (!activeCallerId) return;
    getDataSaving(activeCallerId).then((res: any) => {
      setAccounts(res.data);
      if (res.data?.length > 0) {
        setActiveSaving({
          coaCode: res.data[0].coaCode,
          configId: res.data[0].configId,
        });
      }
    });
  }, [activeCallerId]);

  useEffect(() => {
    if (!accounts.length || !activeCallerId) return;
    Promise.all(
      accounts.map((acc) =>
        getSummarySaving(activeCallerId, acc.coaCode, acc.configId).then(
          (res: any) => res.data,
        ),
      ),
    ).then((summaries) => {
      const global = summaries.reduce(
        (total: any, item: any) => {
          total.totalDepositAmount += Number(item?.totalDepositAmount || 0);
          total.totalWithdrawalAmount += Number(
            item?.totalWithdrawalAmount || 0,
          );
          total.totalTransaction += Number(item?.totalTransaction || 0);
          return total;
        },
        {
          totalBalance,
          totalDepositAmount: 0,
          totalWithdrawalAmount: 0,
          totalTransaction: 0,
        },
      );
      setGlobalSummary(global);
    });
  }, [accounts, activeCallerId]);

  useEffect(() => {
    if (!activeCallerId || !activeSaving) return;
    getSummarySaving(
      activeCallerId,
      activeSaving.coaCode,
      activeSaving.configId,
    ).then((res: any) => {
      setSummaryByCoa(res.data);
    });
    getMutationSaving(
      activeCallerId,
      activeSaving.coaCode,
      activeSaving.configId,
      mutationDateRange,
      dateSort,
      page,
      size,
    ).then((res: any) => {
      setMutationSaving((prev) => ({
        ...prev,
        [activeSaving.configId]: res.data.content || [],
      }));
      setDataMutations(res.data.content);
      setTotalTransaksi(res.data.totalElements);
      setTotal(res.data.totalElements);
      setNumber(res.data.number);
      setNumberOfElements(res.data.numberOfElements);
    });
  }, [activeCallerId, activeSaving, mutationDateRange, page, size, dateSort]);

  type IconComponent = ComponentType<ImgHTMLAttributes<HTMLImageElement>>;

  const mutationConfig = activeSaving
    ? mutationSaving[activeSaving.configId] || []
    : [];

  const totalTabungan = accounts.length;

  type FirstBoxesProps = {
    title: string;
    desc: ReactNode;
    icon: IconComponent;
  };

  const icon = {
    total: TotalIcon,
    totalround: TotalroundIcon,
    transfer: TransferIcon,
    transferround: TransferroundIcon,
    saldo: SaldoIcon,
    saldoround: SaldoroundIcon,
    clipboard: ClipboardIcon,
    clipboardround: ClipboardroundIcon,
  } as const;

  const FirstBoxes = ({ title, desc, icon: Icon }: FirstBoxesProps) => (
    <SwiperSlide className="w-full h-28 bg-white rounded-xl p-3 flex flex-col justify-between border">
      <div className="flex justify-between items-center">
        <div>
          <p className="text-sm text-gray-500 pb-3 -mb-2">{title}</p>
          <strong>
            <p className="text-md">{desc}</p>
          </strong>
        </div>
        <Icon className="text-xs h-10 w-10" />
      </div>
    </SwiperSlide>
  );

  const openDetail = (RowData: any) => {
    setIsModalOpen(true);
    getDetailMutationSaving(RowData.id).then((res: any) => {
      setDetail(res.data);
    });
  };

  // const sortedMutation = useMemo(() => {
  //   return [...mutationConfig].sort((a, b) => {
  //     const timeA = new Date(a.dateTime).getTime();
  //     const timeB = new Date(b.dateTime).getTime();
  //     return dateSort === "terbaru" ? timeB - timeA : timeA - timeB;
  //   });
  // }, [mutationConfig, dateSort]);

  type MutationStatus = "SUCCESS" | "REVERSED";
  type MutationType = "SAVING" | "CASHOUT" | "REVERSED";
  const getMutationType = (item: {
    status: MutationStatus;
    credit: number;
    debit: number;
  }): MutationType => {
    if (item.status === "REVERSED") return "REVERSED";
    if (Number(item.credit) > 0) return "SAVING";
    return "CASHOUT";
  };
  const dataMutation = useMemo(() => {
    return dataMutations && dataMutations.length > 0
      ? dataMutations.map((item: any) => {
          const type = getMutationType(item);
          const amount =
            type === "SAVING" || type === "REVERSED"
              ? Number(item.credit)
              : Number(item.debit);
          return {
            id: item.id,
            tags: `${type} - ${item.savingName}`,
            date: new Date(item.dateTime).toLocaleString("id-ID", {
              day: "2-digit",
              month: "long",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            }),
            nominal: `${amount.toLocaleString("id-ID")},00`,
            sign: type === "CASHOUT" ? "-" : "+",
            status: item.status || "-",
          };
        })
      : [];
  }, [dataMutations]);

  const mutationType: MutationType = detail
    ? getMutationType(detail)
    : "SAVING";

  const mutationTypeDetail = {
    SAVING: {
      title: "Tabungan Berhasil",
      background: "bg-[#0054E6]",
      Icon: SavingIcon,
    },
    CASHOUT: {
      title: "Penarikan Berhasil",
      background: "bg-[#EA0C0C]",
      Icon: SavingIcon,
    },
    REVERSED: {
      title: "Reversal Berhasil",
      background: "bg-[#FFBC00]",
      Icon: ReversalIcon,
    },
  } as const;

  const { title, background, Icon } = mutationTypeDetail[mutationType];
  useEffect(() => {
    const isAllModalOpen = isAccOpen || isModalOpen;
    if (isAllModalOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isAccOpen, isModalOpen]);

  useEffect(() => {
    if (isAccOpen) {
      setButtonAcc(activeCallerId);
    }
  }, [isAccOpen, activeCallerId]);
  useEffect(() => {
    console.log(
      {
        img: getImgContent(activeUser?.photoUrl),
        callerIdentities,
        activeUser,
      },
      null,
      2,
    );
  }, []);

  return (
    <div className="font-montserrat">
      <div className="h-auto bg-psp-primary">
        <div className="mx-none container h-full flex flex-row justify-between relative">
          <div className="flex flex-col rounded-2xl relative bg-white items-center p-8 w-full my-12">
            <div className="flex d-flex w-full">
              <button>
                <ChevronLeft
                  className="bg-white w-8 h-8 rounded-lg border p-1"
                  onClick={() => navigate(`/home`)}
                />
              </button>
              <div className="ml-6 font-bold text-2xl">Tabungan</div>
            </div>
            <section className="my-4 w-full">
              <div className="flex h-28 w-full bg-white rounded-xl border">
                <div className="flex justify-between w-full">
                  <div className="flex items-center justify-between h-20 px-4 mt-3">
                    <img
                      src={
                        getImgContent(activeUser?.photoUrl) ||
                        "https://i.pinimg.com/736x/9e/83/75/9e837528f01cf3f42119c5aeeed1b336.jpg"
                      }
                      alt=""
                      className="w-20 h-20 rounded-full object-cover mr-6"
                    />
                    <div className="font-montserrat">
                      <h1
                        style={{ fontSize: 18 }}
                        className={`m-0 text-sm mb-2`}
                      >
                        {activeUser?.name ?? "-"}
                      </h1>
                      <h1
                        style={{ fontSize: 14 }}
                        className={`m-0 font-normal`}
                      >
                        {activeUser?.callerId ?? "-"}
                      </h1>
                    </div>
                  </div>
                </div>

                <div className="my-auto mr-3">
                  {callerIdentities.length > 1 && (
                    <button
                      className="bg-psp-btn-primary w-48 py-2 px-4 mx-4 rounded-3xl text-white flex d-flex"
                      onClick={() => setIsAccOpen(true)}
                    >
                      <SwitchIcon className="mr-4" />
                      Ganti Anak
                    </button>
                  )}
                </div>
              </div>
            </section>
            <section className="mb-4 w-full">
              <div className="grid grid-cols-4 gap-3">
                <FirstBoxes
                  title="Saldo Keseluruhan"
                  desc={`Rp. ${Number(
                    globalSummary.totalBalance ?? 0,
                  ).toLocaleString("id-ID")},00`}
                  icon={icon.totalround}
                />
                <FirstBoxes
                  title="Total Penarikan"
                  desc={`Rp. ${Number(
                    globalSummary?.totalWithdrawalAmount ?? 0,
                  ).toLocaleString("id-ID")},00`}
                  icon={icon.transferround}
                />
                <FirstBoxes
                  title="Total Saldo Masuk"
                  desc={`Rp. ${Number(
                    globalSummary?.totalDepositAmount ?? 0,
                  ).toLocaleString("id-ID")},00`}
                  icon={icon.saldoround}
                />
                <FirstBoxes
                  title="Total Tabungan"
                  desc={`${totalTabungan}`}
                  icon={icon.clipboardround}
                />
              </div>
            </section>
            <hr className="w-full" />
            <section className="mb-4 w-full">
              <Swiper
                modules={[Pagination]}
                spaceBetween={10}
                slidesPerView={4.1}
                centeredSlides={false}
                pagination={{
                  clickable: true,
                  el: ".custom-pagination-container", // Menunjuk ke div di luar swiper
                  bulletClass:
                    "swiper-pagination-bullet !mx-1 transition-all duration-300",
                  bulletActiveClass:
                    "swiper-pagination-bullet-active !w-8 !rounded-full !bg-blue-600",
                }}
                className="pb-8" // Memberi ruang sedikit di bawah slide
              >
                {accounts.map((acc: SavingType, index: number) => {
                  const isActive = acc.configId === activeSaving?.configId;
                  return (
                    <SwiperSlide key={index}>
                      <BalanceCard
                        hasBorder={true}
                        data={acc}
                        isActive={isActive}
                        activeUser={callerIdentities.filter(
                          (i) => i.callerId === activeCallerId,
                        )}
                        onClick={() => {
                          setActiveSaving({
                            coaCode: acc.coaCode,
                            configId: acc.configId,
                          });
                        }}
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              <div className="custom-pagination-container flex justify-center mt-2 h-2" />
            </section>
            <section className="w-full">
              <div className="grid grid-cols-4 gap-3">
                <FirstBoxes
                  title="Total Saldo"
                  desc={`Rp. ${Number(
                    activeAccount?.balance ?? 0,
                  ).toLocaleString("id-ID")},00`}
                  icon={icon.total}
                />
                <FirstBoxes
                  title="Total Penarikan"
                  desc={`Rp. ${Number(
                    summaryByCoa?.totalWithdrawalAmount ?? 0,
                  ).toLocaleString("id-ID")},00`}
                  icon={icon.transfer}
                />
                <FirstBoxes
                  title="Total Saldo Masuk"
                  desc={`Rp. ${Number(
                    summaryByCoa?.totalDepositAmount ?? 0,
                  ).toLocaleString("id-ID")},00`}
                  icon={icon.saldo}
                />
                <FirstBoxes
                  title="Total Transaksi"
                  desc={`${totalTransaksi}`}
                  icon={icon.clipboard}
                />
              </div>
            </section>
            <section className="w-full my-8">
              Urutkan: {""}
              <select
                value={dateSort}
                onChange={(e) =>
                  setDateSort(
                    e.target.value as "dateTime,Desc" | "dateTime,Asc",
                  )
                }
                className="border rounded-full bg-white p-1 ml-2 mb-4 text-sm"
              >
                <option value="dateTime,Desc">Tanggal Terbaru</option>
                <option value="dateTime,Asc">Tanggal Terlama</option>
              </select>
              <div className="w-full right-0 left-0 h-[50vh] overflow-auto">
                <table className="w-full bg-white">
                  <thead className="sticky top-0 bg-white">
                    <tr className="border-t w-full justify-between">
                      <th className="p-3 font-medium text-base">
                        Jenis Tabungan
                      </th>
                      <th className="p-3 font-medium text-base">
                        Tanggal Menabung
                      </th>
                      <th className="p-3 font-medium text-base">Nominal</th>
                      <th className="p-3 font-medium text-base">keterangan</th>
                      <th className="p-3 font-medium text-base">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataMutation.map((item: any, index: number) => (
                      <tr
                        className={`text-sm ${index % 2 === 0 ? "bg-slate-100" : "bg-white"}`}
                      >
                        <td className="p-3 font-light">{item.tags}</td>
                        <td className="p-3 font-light">{item.date}</td>
                        <td className="p-3 font-light">
                          {item.sign}
                          {"Rp. "}
                          {item.nominal}
                        </td>
                        <td className="p-3 font-light">{item.status}</td>
                        <td className="p-3 font-light">
                          <div className="flex justify-center">
                            <button
                              onClick={() => openDetail(item)}
                              className="flex d-flex px-3 py-1 text-sm bg-[#424951] items-center text-white rounded-full"
                            >
                              <TextAlignJustify className="text-white w-6 h-6 pb-1 pr-3" />
                              Detail
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex relative mt-10 justify-between font-montserrat">
                <div className="pt-2 w-1/4 font-montserrat">
                  <span className="font-montserrat">
                    {t("OTHER.showing")} {showingFrom} {t("OTHER.to")}{" "}
                    {showingTo} {t("OTHER.from")} {total} data
                  </span>
                </div>
                <div className="w-auto">
                  <div className="font-montserrat">
                    <select
                      onChange={(value) => {
                        changeSize(Number(value.target.value));
                      }}
                      value={size}
                      className="py-2 border rounded-lg bg-white font-montserrat"
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={1000}>1000</option>
                    </select>
                    <span className="ml-1">{t("OTHER.entry")}</span>
                  </div>
                </div>
                <div className="flex w-1/4 font-montserrat">
                  <button
                    onClick={() => changePage(page - 1)}
                    disabled={page === 0}
                    className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                  >
                    {t("OTHER.previous")}
                  </button>
                  <button
                    onClick={() => changePage(page + 1)}
                    disabled={(page + 1) * size > total}
                    className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                  >
                    {t("OTHER.next")}
                  </button>
                </div>
              </div>
            </section>
            <section>
              {isAccOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                  <div
                    className="absolute inset-0 bg-black/40"
                    onClick={() => setIsAccOpen(false)}
                  ></div>
                  <div className="relative bg-white rounded-2xl p-6 w-[90%] max-w-md">
                    <div className="flex flex-col">
                      {callerIdentities.map((item) => {
                        const isSelected = item.callerId === buttonAcc;
                        return (
                          <div
                            key={item.callerId}
                            className={`flex items-center justify-between h-20 px-4 mb-3 rounded-xl mx-8
                              ${
                                isSelected
                                  ? "border-2 border-psp-primary"
                                  : "border border-gray-500"
                              }`}
                            onClick={() => {
                              setActiveuser(item);
                              setButtonAcc(item.callerId);
                            }}
                          >
                            <div className="flex items-center justify-center my-8">
                              <img
                                src={
                                  getImgContent(item.photoUrl) ||
                                  "https://i.pinimg.com/736x/9e/83/75/9e837528f01cf3f42119c5aeeed1b336.jpg"
                                }
                                alt=""
                                className="w-12 h-12 rounded-full object-cover"
                              />
                              <div className="flex items-center ml-6">
                                <div className="flex flex-col leading-tight">
                                  <span>{item.name}</span>
                                  <span>{item.callerId}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="flex flex-row px-3 gap-24 mt-6 items-center justify-center">
                      <button
                        className="bg-[#F62D51] rounded-full w-32 h-8 text-white text-sm"
                        onClick={() => {
                          setIsAccOpen(false);
                          setButtonAcc(null);
                        }}
                      >
                        Batal
                      </button>
                      <button
                        className="bg-psp-btn-primary rounded-full w-32 h-8 text-white text-sm"
                        onClick={() => {
                          setActiveCallerId(buttonAcc);
                          setIsAccOpen(false);
                        }}
                      >
                        Pilih
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </section>
            <section>
              {isModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                  <div
                    className="absolute inset-0 bg-black/40"
                    onClick={() => setIsModalOpen(false)}
                  ></div>
                  <div className="relative bg-white rounded-2xl px-6 w-fit h-fit max-w-[90vw] max-h-[90vh] overflow-y-auto">
                    <div className="flex flex-col">
                      {detail && (
                        <>
                          <div className="flex items-center justify-between">
                            <span className="flex d-flex">
                              <DesktopSavingIcon />
                              <p className="mt-3 ml-4">
                                Tabungan {detail.callerName}
                              </p>
                            </span>
                            <button>
                              <X onClick={() => setIsModalOpen(false)} />
                            </button>
                          </div>
                          <div className="flex flex-row mt-4 px-4 gap-24">
                            <div className="text-center py-4">
                              <section className="mb-8 flex flex-col gap-3 items-center justify-center">
                                <div
                                  className={`w-20 h-20 ${background} flex flex-col px-3 justify-center text-center rounded-full`}
                                >
                                  <Icon className="w-12 h-12 text-white mt-2" />
                                </div>
                              </section>
                              <div className="flex flex-col">
                                <h1
                                  style={{ fontSize: 16 }}
                                  className="font-semibold"
                                >
                                  {title}
                                </h1>
                                <p className="text-xs mb-0 text-gray-500">
                                  Tanggal{" "}
                                  {new Date(detail.dateTime).toLocaleDateString(
                                    "id-ID",
                                    {
                                      day: "2-digit",
                                      month: "long",
                                      year: "numeric",
                                    },
                                  )}
                                </p>
                                <p className="text-sm text-gray-500">
                                  {new Date(detail.dateTime).toLocaleTimeString(
                                    "id-ID",
                                    {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    },
                                  )}
                                </p>
                                <p className="text-xs mb-0 text-gray-500">
                                  Nominal
                                </p>
                                <p className="text-lg font-semibold">
                                  Rp.{" "}
                                  {Number(
                                    detail.credit || detail.debit,
                                  ).toLocaleString("id-ID")}
                                  ,00
                                </p>
                              </div>
                            </div>
                            <div>
                              <div className="text-xs mb-2">
                                <div className="flex items-center justify-between">
                                  <h1
                                    style={{ fontSize: 18 }}
                                    className="font-semibold"
                                  >
                                    Data Pembayaran
                                  </h1>
                                  <button
                                    onClick={() => toggleArrow("pembayaran")}
                                  >
                                    <ChevronDown
                                      className={`mb-2 ml-28 transition-transform ${
                                        openArrow.includes("pembayaran")
                                          ? "rotate-180"
                                          : ""
                                      }`}
                                    />
                                  </button>
                                </div>
                                {openArrow.includes("pembayaran") && (
                                  <div className="mt-2 text-xs">
                                    <div className="flex justify-between">
                                      <p>Nama Siswa</p>
                                      <p className="mt-0">
                                        {detail.callerName}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="text-xs mb-2">
                                <div className="flex items-center justify-between">
                                  <h1
                                    style={{ fontSize: 18 }}
                                    className="font-semibold"
                                  >
                                    Detail Transaksi
                                  </h1>
                                  <button
                                    onClick={() => toggleArrow("transaksi")}
                                  >
                                    <ChevronDown
                                      className={`mb-2 transition-transform ${
                                        openArrow.includes("transaksi")
                                          ? "rotate-180"
                                          : ""
                                      }`}
                                    />
                                  </button>
                                </div>
                                {openArrow.includes("transaksi") && (
                                  <div className="mt-2 text-xs">
                                    <div className="flex justify-between">
                                      <p>Nama Tabungan</p>
                                      <p className="mt-0">
                                        {detail.savingName}
                                      </p>
                                    </div>
                                    <div className="flex justify-between">
                                      <p>Tanggal Tagihan</p>
                                      <p className="mt-0">
                                        {new Date(
                                          detail.dateTime,
                                        ).toLocaleDateString("id-ID")}
                                      </p>
                                    </div>
                                    <div className="grid grid-cols-2 gap-4">
                                      <p>Tipe Tagihan</p>
                                      <p className="mt-0 text-right break-words">
                                        {detail.transactionName}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="text-xs mb-2">
                                <div className="flex items-center justify-between">
                                  <h1
                                    style={{ fontSize: 18 }}
                                    className="font-semibold"
                                  >
                                    Rincian
                                  </h1>
                                  <button
                                    onClick={() => toggleArrow("rincian")}
                                  >
                                    <ChevronDown
                                      className={`mb-2 transition-transform ${
                                        openArrow.includes("rincian")
                                          ? "rotate-180"
                                          : ""
                                      }`}
                                    />
                                  </button>
                                </div>
                                {openArrow.includes("rincian") && (
                                  <div className="mt-2 text-xs">
                                    <div className="flex justify-between">
                                      <p>Status Tabungan</p>
                                      <p className="mt-0">
                                        {detail.status === "SUCCESS"
                                          ? "Berhasil"
                                          : "Reversal"}
                                      </p>
                                    </div>
                                    <div className="flex justify-between">
                                      <p>Nominal</p>
                                      <p className="mt-0">
                                        Rp.{" "}
                                        {Number(
                                          detail.credit || detail.debit,
                                        ).toLocaleString("id-ID")}
                                        ,00
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SavingWeb;
